<template>
    <section class="url-upload-header" :class="{error: error}">
      <input
        type="text"
        class="library-search-bar-input url-input"
        :placeholder="$t('ADD_URL')"
        v-model="url"
        @keyup.enter="updateUrl"
        @blur="updateUrl"
        @focus="setUrl(null)"
        ref="search"
      />
      <div v-if="error && !validUrl">
        <span v-if="!notSecureUrl" class="error-text">{{$t("URL_NOT_VALID")}}</span>
        <span v-if="notSecureUrl" class="error-text">{{$t("URL_NOT_HTTPS")}}</span>
      </div>
      <span v-else class="error-text">{{ $t("ERROR_TEXT") }}</span>
    </section>
</template>

<script>
import { mapState } from 'vuex'
import { isUrlValid } from '@/utilityFunctions'
export default {
  name: 'url-upload-header',
  data () {
    return {
      url: null,
      error: null,
      validUrl: false,
      notSecureUrl: false
    }
  },
  created () {
    this.$nextTick(function () {
      this.$refs.search.focus()
    })
    if (this.selectedEntryOrigin === 'collectionEntry') {
      this.url = this.selectedEntry.object.url
    }
  },
  computed: {
    ...mapState({
      selectedEntryOrigin: state => state.collections.selectedEntryOrigin,
      selectedEntry: state => state.collections.selectedEntry
    })
  },

  methods: {
    setUrl (val) {
      this.$store.dispatch('setUploadUrl', val)
    },
    async updateUrl () {
      this.notSecureUrl = false
      if (this.url.indexOf('http://') === 0) {
        this.validUrl = false
        this.error = true
        this.notSecureUrl = true
        return
      }
      this.validUrl = await isUrlValid(this.url)
      if (!this.validUrl) {
        this.error = true
        this.setUrl(null)
        return
      }
      if (this.url === '') {
        this.error = true
      } else {
        this.error = false
      }
      this.setUrl(this.url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .library-search-bar{
    width: 90%; margin: 0 auto;
  }
</style>
